import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MinutesToHoursPipe } from './pipes/minutes-to-hours.pipe';
import { NbSpacePipe } from './pipes/nb-space-pipe';

@NgModule({
  declarations: [MinutesToHoursPipe, NbSpacePipe],
  imports: [CommonModule],
  exports: [MinutesToHoursPipe, NbSpacePipe]
})
export class PipesModule {}
